import { Box, styled } from '@material-ui/core';

const StyledSvgLogo = styled(Box)(() => ({
  padding: 0,
  margin: 0,
}));

export { StyledSvgLogo };
